import React from 'react'
import { connect } from 'react-redux'
import { Form, reduxForm, formValueSelector, change } from 'redux-form'
import { useHistory } from 'react-router-dom'
import StyledSVG from '../components/shared/StyledSVG'
import pickupIcon from '../assets/icons/pickup-icon.svg'
import Button from '../components/button/Button'
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import SearchPickupQueueForm from '../components/form/SearchPickupQueueForm'
import {
  getPickupQueue,
  clearPickupQueues
} from './../store/pickup_queue/actions'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '98%',
    [theme.breakpoints.down('600')]: {
      padding: 16
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093',
        [theme.breakpoints.down('850')]: {
          fontSize: 25,
          textAlign: 'center'
        }
      }
    },
    [theme.breakpoints.down('850')]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  }
}))

const TitleComponent = ({ todayQueues }) => {
  if (todayQueues) {
    return <h1>Total de saídas de hoje</h1>
  }
  return <h1>Histórico de saídas</h1>
}
const SubtitleComponene = ({ todayQueues }) => {
  if (todayQueues) {
    return (
      <p className='subtitle'>
        Veja todas as retiradas realizadas no dia, com detalhes de horário,
        responsável e status de segurança.
      </p>
    )
  }
  return (
    <p className='subtitle'>
      Acompanhe todas as retiradas realizadas na escola e gere relatórios de
      segurança e presença.
    </p>
  )
}

const PickupHistoryPage = ({
  componentAttribute,
  handleSubmit,
  onSubmit,
  schoolId,
  change,
  getPickupQueue,
  clearPickupQueues,
  queues,
  gradeValue,
  classroomValue,
  relationshipValue,
  statusValue,
  nameValue,
  touch,
  pickupFinalDateValue,
  pickupInitialDateValue,
  authorizationTypeValue
}) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('850'))
  const todayQueues = componentAttribute?.today
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          {matches && <StyledSVG height={28} width={28} src={pickupIcon} />}
          <TitleComponent todayQueues={todayQueues} />
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <SubtitleComponene todayQueues={todayQueues} />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <SearchPickupQueueForm
          getPickupQueue={getPickupQueue}
          clearPickupQueues={clearPickupQueues}
          queues={queues}
          schoolId={schoolId}
          change={change}
          gradeValue={gradeValue}
          classroomValue={classroomValue}
          relationshipValue={relationshipValue}
          pickupInitialDateValue={pickupInitialDateValue}
          pickupFinalDateValue={pickupFinalDateValue}
          authorizationTypeValue={authorizationTypeValue}
          statusValue={statusValue}
          nameValue={nameValue}
          touch={touch}
          todayQueues={todayQueues}
        />
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('searchPickupQueueForm')
  return {
    schoolId: state.school?.currentSchool?.school_id,
    gradeValue: selector(state, 'grade_id'),
    classroomValue: selector(state, 'classroom_id'),
    relationshipValue: selector(state, 'relationship_type'),
    pickupInitialDateValue: selector(state, 'pickup_date_initial'),
    pickupFinalDateValue: selector(state, 'pickup_date_final'),
    authorizationTypeValue: selector(state, 'authorization_type'),
    statusValue: selector(state, 'status'),
    nameValue: selector(state, 'name'),
    queues: state.pickup_queues
  }
}

const mapDispatchToProps = dispatch => ({
  getPickupQueue: data => dispatch(getPickupQueue(data)),
  clearPickupQueues: () => dispatch(clearPickupQueues()),
  change: (field, data) =>
    dispatch(change('searchPickupQueueForm', field, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchPickupQueueForm',
    onSubmit: async (values, dispatch, props) => {}
  })(PickupHistoryPage)
)
